import { CalendarCheck } from 'lucide-react';
import { useReservation } from '@/lib/reservation';
import { trackEvent } from '@/lib/analytics';
import {
    RESERVATIONS_ENABLED,
    RESERVATION_DISABLED_MESSAGE,
} from '@/lib/data';
import { cn } from '@/lib/utils';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@/components/ui/tooltip';

const sizeClasses = {
    sm: 'px-5 py-2.5 text-sm',
    md: 'px-7 py-3.5 text-base',
    lg: 'px-7 py-3.5 text-base sm:text-lg',
};

const toneClasses = {
    gradient:
        'bg-gradient-fun text-white shadow-pop hover:brightness-110 active:brightness-95',
    yellow:
        'bg-[hsl(var(--kche-yellow))] text-[hsl(var(--kche-dark))] shadow-pop hover:scale-[1.03] active:scale-[0.98]',
};

export const ReservationButton = ({
    children = 'Reserva Online',
    from = 'reservation_button',
    defaults = {},
    size = 'md',
    tone = 'gradient',
    full = false,
    testId = 'reservation-button',
    className = '',
}) => {
    const { openReservation } = useReservation();

    const baseClass = cn(
        'inline-flex items-center justify-center gap-2 rounded-full font-bold font-display transition',
        sizeClasses[size],
        full && 'w-full',
        className
    );

    if (!RESERVATIONS_ENABLED) {
        return (
            <TooltipProvider delayDuration={120}>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <button
                            type="button"
                            aria-disabled="true"
                            data-testid={testId}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                            }}
                            className={cn(
                                baseClass,
                                'bg-gray-300 text-gray-600 cursor-default shadow-none grayscale hover:bg-gray-400 hover:text-gray-700 hover:scale-100'
                            )}
                        >
                            <CalendarCheck className="size-5" />
                            {children}
                        </button>
                    </TooltipTrigger>

                    <TooltipContent
                        side="top"
                        className="rounded-xl bg-slate-950 text-white border border-white/10 px-3 py-2 text-xs shadow-xl"
                    >
                        {RESERVATION_DISABLED_MESSAGE}
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        );
    }

    return (
        <button
            type="button"
            data-testid={testId}
            onClick={() => {
                trackEvent('cta_click', window.location.pathname, {
                    from,
                    cta: 'reserva_online',
                });
                openReservation(defaults);
            }}
            className={cn(baseClass, toneClasses[tone])}
        >
            <CalendarCheck className="size-5" />
            {children}
        </button>
    );
};

export default ReservationButton;